import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";
import { useAuth } from "../hooks/use-auth";
import api from "../services/api";
const TenantFeatures = createContext({
  protocolsEnabled: false,
  schedulingEnabled: false,
  loading: true,
  failed: false,
  refresh: () => {},
});
export function TenantFeaturesProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const [state, setState] = useState({
    protocolsEnabled: false,
    schedulingEnabled: false,
    loading: true,
    failed: false,
  });
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision((value) => value + 1), []);
  useEffect(() => {
    let cancelled = false;
    setState({
      protocolsEnabled: false,
      schedulingEnabled: false,
      loading: Boolean(user?.appName),
      failed: false,
    });
    if (user?.appName)
      api
        .get(`/tenant/${encodeURIComponent(user.appName)}`)
        .then((res) => {
          if (!cancelled)
            setState({
              protocolsEnabled: res.data.protocolsEnabled === true,
              schedulingEnabled: res.data.enabledScheduling === true,
              loading: false,
              failed: false,
            });
        })
        .catch(() => {
          if (!cancelled)
            setState({
              protocolsEnabled: false,
              schedulingEnabled: false,
              loading: false,
              failed: true,
            });
        });
    return () => {
      cancelled = true;
    };
  }, [user?.appName, revision]);
  return (
    <TenantFeatures.Provider value={{ ...state, refresh }}>
      {children}
    </TenantFeatures.Provider>
  );
}
export const useTenantFeatures = () => useContext(TenantFeatures);
